import { render, staticRenderFns } from "./otherTeam.vue?vue&type=template&id=17be7b27&scoped=true&"
import script from "./otherTeam.vue?vue&type=script&lang=js&"
export * from "./otherTeam.vue?vue&type=script&lang=js&"
import style0 from "./otherTeam.vue?vue&type=style&index=0&id=17be7b27&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17be7b27",
  null
  
)

export default component.exports